
  import { computed, toRaw } from 'vue';
  import { useRoute, useRouter } from 'vue-router';
  import BaseIcon from '../../BaseIcon/src/BaseIcon.vue';

  export default {
    name: 'BasePageHeader',
    components: {
      BaseIcon,
    },
    props: {
      title: {
        type: String,
        default: '',
      },
      simple: {
        type: Boolean,
        default: false,
      },
      hideBack: {
        type: Boolean,
        default: false,
      },
    },
    setup(props) {
      const { hideBack } = toRaw(props);
      const router = useRouter();
      const route = useRoute();
      function back() {
        router.back();
      }
      const isRealHide = computed(() => hideBack == true || route.query.f == 'wx');
      return {
        isRealHide,
        back,
      };
    },
  };
